import React from 'react';
import { Grid } from '@material-ui/core';
import { useNavigate } from 'react-router';
import SingleMetricCard from 'components/common/SingleMetricCard';
import AssignmentIcon from '@material-ui/icons/Assignment';
import MasonryGrid from 'components/Masonry/MasonryGrid';
import { JobTableType } from 'api/jobApi';
import { buildJobListUrl } from 'components/Jobs/jobListUrlParams';

interface Props {
  overviewData?: {
    userPermittedJobCount?: number;
    userClosedJobCount?: number;
    userOpenJobCount?: number;
  };
}

const LimitedUserGridItems = ({ overviewData }: Props) => {
  const navigate = useNavigate();
  const screenWidthToColumns = {
    xs: [12],
    sm: [6, 6],
    md: [6, 6],
    lg: [4, 4, 4],
    xl: [4, 4, 4],
  };

  return (
    <>
      <MasonryGrid screenWidthToColumns={screenWidthToColumns}>
        <Grid item>
          <SingleMetricCard
            metric={overviewData?.userPermittedJobCount}
            label="CURRENTLY PERMITTED JOBS"
            description="The number of jobs that you have access to."
            icon={<AssignmentIcon />}
            onClick={() =>
              navigate(buildJobListUrl({ tab: JobTableType.ALL }))
            }
          />
        </Grid>
        <Grid item>
          <SingleMetricCard
            metric={overviewData?.userOpenJobCount}
            label="OPEN JOBS COUNT"
            description="The number of open jobs that you have access to."
            icon={<AssignmentIcon />}
            onClick={() =>
              navigate(buildJobListUrl({ tab: JobTableType.OPEN }))
            }
          />
        </Grid>
        <Grid item>
          <SingleMetricCard
            metric={overviewData?.userClosedJobCount}
            label="CLOSED JOBS COUNT"
            description="The number of completed or cancelled jobs that you have access to."
            icon={<AssignmentIcon />}
            onClick={() =>
              navigate(buildJobListUrl({ tab: JobTableType.CLOSED }))
            }
          />
        </Grid>
      </MasonryGrid>
    </>
  );
};

export default LimitedUserGridItems;
